import Icon from "../../../components/icons/";

export const AlertItem = (props) => {
  const { title, time, ownerable_user_name, color } = props;

  return (
    <div className="c-calendar-alert-item">
      <div className="c-calendar-alert-item__title">
        <Icon
          name="Notification"
          color={color}
          width={21}
          height={24}
          noWrapper={true}
        />
        <span style={{ color: color }}>{title}</span>
      </div>
      <p>{time}</p>
      <p className="c-calendar-alert-item__name">{ownerable_user_name}</p>
    </div>
  );
};
